import Mustache from 'mustache';
var Cookies = require('./thirdparty/jquery.cookie.js');

window.messages = {
    "deleteOne": "This will delete your favourite. Do you want to proceed?",
    "deleleAll": "This will delete all favourites inside this list. Do you want to proceed?"
};


(function ($) {

    var loader = $('<div class="ssf-loader"></div>');
    var favouriteIconTemplate = $('#favourite-icon-template');
    var Clipboard = require('clipboard');
    var favPopup = jQuery('._js-fav-popup');
    var serverFavListData = null;
    var configs = [];

    var FavData = {
        Events: {}
    };
    var dbFavData = window.localStorage.getItem('favourite_data');
    if (dbFavData) FavData = JSON.parse(dbFavData);

    setInterval(function () {
        dbFavData = window.localStorage.getItem('favourite_data');
        if (dbFavData) {
            FavData = JSON.parse(dbFavData);
            updateFavCount();
        }
    }, 500);

    updateFavCount();

    // utility function: dispatch events to be caught by the site theme
    function dispatchFavEvent(eventName) {

        const event = new Event(eventName);

        document.dispatchEvent(event);
    }

    function instConfigs() {
        var meta = document.getElementById('fav_configs');
        if (meta) {
            var json = meta.getAttribute('content');
            var data = JSON.parse(json);
            configs = data;
        }
    }

    function getConfig(name) {
        if (typeof configs[name] != 'undefined') {
            return configs[name];
        }
    }

    function initFavIcon(target) {
        if (!serverFavListData) {
            $.getJSON(getConfig('favouriteListLink'), function (data) {
                serverFavListData = data;
                initFavIconWithData(target);
            });
        }
        else {
            initFavIconWithData(target);
        }
    }

    function initFavIconWithData(target) {
        if (target && $(target).find('.js-fav-icon').length) {
            var favIcons = $(target).find('.js-fav-icon');
            if (favIcons.length) {
                if (favouriteIconTemplate.length) {
                    favIcons.each(function () {
                        var $this = $(this);
                        if (!$this.hasClass('js-init')) {
                            var renderData = {
                                'FavID': $this.data('id'),
                                'DefaultFavListID': serverFavListData.DefaultList,
                                'FavLists': serverFavListData.FavList,
                                'ShowFavList': serverFavListData.FavList.length > 1,
                                'AddLabel': $this.data('addLabel'),
                                'RemoveLabel': $this.data('removeLabel'),
                                'Name': $this.data('name'),
                            };
                            $this.addClass('js-init');
                            $this.html(
                                Mustache.render(favouriteIconTemplate.html(), renderData)
                            );
                        }
                    });
                }
                var favLists = $(target).find('.js-fav-list-item');

                checkIconsAndLists(favIcons, favLists);
            }
        }
    }

    /**
     * Expose the function for external call.
     * @type {initFavIcon}
     */
    window.initFavIcon = initFavIcon;


    instConfigs();
    initFavIcon($('body'));


    function toggleFavIcon(dom) {
        if (isItemAdded(dom.data('id'))) {
            dom.find('.js-heart-icon-open').hide();
            dom.find('.js-heart-icon').show();
        } else {
            dom.find('.js-heart-icon').hide();
            dom.find('.js-heart-icon-open').show();
        }
    }

    //This function was added because Broken shed has two add to favourites buttons on their Blog pages.  This keeps them in sync.
    function updateAllFavIcons() {
        var favIcons = $('body').find('.js-fav-icon');
        if (favIcons.length) {
            favIcons.each(function () {
                var $this = $(this);
                toggleFavIcon($this);
            });
        }
    }

    //Call after init on all favouritable pages, sets icons to correct state and adds event handlers
    function checkIconsAndLists(favIcons, favLists) {
        var bFavIcons = favIcons.length;
        var bFavLists = favLists.length;
        if (bFavIcons) {
            favIcons.each(function () {
                var $this = $(this);
                toggleFavIcon($this);

                var favItem = $this.find('.js-fav-item');
                favItem.off('click');
                favItem.on('click', function (e) {
                    var favId = $(this).data('favId');
                    var favListId = $(this).data('favList');
                    if (favId && favListId) {
                        addFavItem($(this));
                    } else if (favId && !favListId) {
                        if ($('body').hasClass('FavouritesPage')) {
                            if (confirm(messages.deleteOne)) {
                                removeFavItem($(this));
                            }
                        } else {
                            removeFavItem($(this));
                        }
                    } else if (bFavLists) {
                        $(this).closest('.js-fav-icon').find('.js-fav-popover').toggle();
                        $(this).parent().toggleClass('active');
                        e.stopPropagation();
                    }
                });
            });
        }

        if (bFavLists) {
            favLists.each(function () {
                var $this = $(this);
                $this.on('click', function () {
                    addFavItem($this);
                    $(this).closest('.js-fav-icon').removeClass('active');
                });
            });
            $(document.body).click(function () {
                $('.js-fav-popover').parent().removeClass('active');
            });
        }

        addFavItemAfterloggedIn(favIcons);
    }

    function addFavItemAfterloggedIn(favIcons) {
        var favItemToBeAddedAfterloggedIn = getConfig('favIdToAddAfterLoggedIn');
        if (favItemToBeAddedAfterloggedIn && !isItemAdded(favItemToBeAddedAfterloggedIn)) {
            var favIcon = favIcons.filter(function () {
                return $(this).data("id") == favItemToBeAddedAfterloggedIn
            });
            if (favIcon.find('.js-fav-popover').length) {
                addFavItem(favIcon.find('.js-fav-popover .js-fav-list-item').first())
            } else {
                addFavItem(favIcon.find('.js-heart-icon-open'))
            }
        }
    }

    function isItemAdded(id) {
        id = idWithTOPage(id);
        for (var list in FavData.Events) {
            if (FavData.Events[list]) {
                if ((list in FavData.Events) && FavData.Events[list].indexOf(id) >= 0) {
                    return true;
                }
            }
        }
        return false;
    }

    function getSortedURL(url) {
        var pairs = url.substring(url.indexOf('?') + 1).split('&');
        pairs = pairs.sort();
        return pairs.join('&');
    }

    function idWithTOPage(currentId) {
        if (currentId && currentId.match(/TOPage/g)) {
            var searchURL = window.location.href.split(location.host)[1].replace(/^\//, ''),
                arrParams = searchURL.split('?'),
                searchPageBaseURL = arrParams[0],
                searchQuery = arrParams[1];
            if (searchQuery) {
                searchQuery = getSortedURL(searchQuery);
                searchURL = searchPageBaseURL + '?' + searchQuery;
            }
            var arrStrings = currentId.split('--');
            var className = arrStrings[0];
            var id = arrStrings[1];
            if (arrStrings.length == 3) {
                return currentId
            } else {
                return className + '--' + searchURL + '--' + id;
            }
        } else {
            return currentId
        }
    }

    function isListEmpty(list) {
        return (!(list in FavData.Events) || FavData.Events[list].length == 0)
    }

    function allListCount() {
        var length = 0;
        for (var list in FavData.Events) {
            if (FavData.Events[list]) {
                length += FavData.Events[list].length;
            }

        }
        return length;
    }

    function addFavItem(favItem) {
        if (toggleFbFavPopup(favItem)) {
            return false;
        }
        var id = favItem.data('favId'),
            list = favItem.data('favList');
        console.log(list);
        console.log(id);
        console.log(FavData.Events);
        console.log(Object.keys(FavData.Events));
        console.log(Object.keys(FavData.Events)[0]);
        //find existing list
        if (Object.keys(FavData.Events)[0]) {
            list = Object.keys(FavData.Events)[0];
        }
        console.log(list);
        if (!list) {
            list = 1;
        }
        if (!(list in FavData.Events)) {
            FavData.Events[list] = [];
        }
        if (FavData.Events[list].indexOf(id) == -1) {
            id = idWithTOPage(id);
            FavData.Events[list].push(id);
        }
        window.localStorage.setItem('favourite_data', JSON.stringify(FavData));

        var favIcon = $(favItem).closest('.js-fav-icon');
        favIcon.find('.js-heart-icon').show();
        favIcon.find('.js-heart-icon-open').hide();

        var favPopupOver = favItem.closest('.js-fav-icon').find('.js-fav-popover');
        if (favPopupOver.length) {
            favPopupOver.hide();
        }
        updateAllFavIcons();
        updateFavCount();
        updateBackEnd(list);
    }

    function updateFavCount() {
        $('.js-header-nav-fav').text(allListCount());
    }

    function removeFavItem(favItem) {
        var favId = favItem.data('favId');
        var id = idWithTOPage(favId);
        var selectedList;
        for (var list in FavData.Events) {
            if ((list in FavData.Events) && FavData.Events[list].indexOf(id) != -1) {
                removeFromArray(FavData.Events[list], id);
                selectedList = list;
                break;
            }
        }
        window.localStorage.setItem('favourite_data', JSON.stringify(FavData));
        if (favItem.hasClass('js-remove-item') || $('body').hasClass('FavouritesPage')) {
            removeElementFromDOM(favItem);
        }

        var favIcon = favItem.closest('.js-fav-icon');
        favIcon.find('.js-heart-icon').hide();
        favIcon.find('.js-heart-icon-open').show();

        updateAllFavIcons();
        updateFavCount();
        updateBackEnd(selectedList);
        deleteFromEmail(favId);

        dispatchFavEvent('removeFavItem');

    }

    function removeElementFromDOM(favIcon) {
        favIcon.closest('.js-fav-result').remove();
    }

    function removeFromArray(arr) {
        var what, a = arguments, L = a.length, ax;
        while (L > 1 && arr.length) {
            what = a[--L];
            while ((ax = arr.indexOf(what)) !== -1) {
                arr.splice(ax, 1);
            }
        }
        return arr;
    };

    function updateBackEnd(list) {
        if (getConfig('loggedIn')) {
            var processLink = getConfig('processLink');
            $.post(processLink, {
                'ListItems': FavData.Events[list],
                'ListID': list
            });
        }
    }

    function toggleFbFavPopup(favIcon) {
        var bRet = false;
        var userID = getConfig('loggedIn');
        if (getConfig('isBackEnd') && (typeof userID == 'undefined' || userID == 0)) {
            var expireDate = new Date();
            expireDate.setMinutes(expireDate.getMinutes() + 20);
            if (typeof Cookies.get('show_fb_fav_popup') == 'undefined' && document.getElementById('ssf-facebook')) {
                bRet = true;
                $.magnificPopup.open({
                    closeOnBgClick: false,
                    items: {
                        src: '#ssf-facebook',
                        type: 'inline'
                    }
                });
                // set fb signup mfp object for usage (remove/update) of out side favorites module
                window.initialFbLoginPopup = $.magnificPopup.instance;

                if (favIcon) {
                    var favId = favIcon.data('favId');
                    $('.js-close-popup').data('favId', favId);
                    $('.mfp-close').data('favId', favId);
                    Cookies.set('fav_to_be_added_after_logged_in', favId, { 'expires': expireDate });
                }
                Cookies.set('show_fb_fav_popup', '1', { 'expires': expireDate });
            }
        }
        return bRet;
    }

    $(document).on('click', '.js-close-popup, .mfp-close', function (e) {
        e.preventDefault();
        var favId = $(this).data('favId');
        if (favId) {
            var favIcon = $('.js-fav-item').filter(function () {
                return $(this).data('favId') == favId;
            });
            if (favIcon) {
                addFavItem(favIcon);
            }
        }
        $.magnificPopup.close();
        return false;
    });

    // Render/Update a users favourited items on Favourites Page.
    var favWrapper = $('.js-fav-wrapper');
    if (favWrapper.length) {
        favWrapper.on('loadFavItems', function () {
            toggleFavIcon(favWrapper);
        });
        if (favWrapper.data('favUpdateLink')) {
            updateFromBackEnd(favWrapper.data('favUpdateLink'));
        } else if (favWrapper.data('favRenderLink')) {
            renderFavItems(favWrapper.data('favRenderLink'));
            toggleFbFavPopup();
        }
    }

    function updateFromBackEnd(updateLink) {
        $.post(updateLink, { Lists: FavData.Events }).done(function (response) {
            if (response) {
                FavData = JSON.parse(response);
                window.localStorage.setItem('favourite_data', response);
                updateFavCount();

                // render after merge local storage and db data
                if (favWrapper.data('favRenderLink')) {
                    renderFavItems(favWrapper.data('favRenderLink'));
                    toggleFbFavPopup();
                }
            }
        });
    }

    function deleteFromEmail(source) {
        $('.js-fav-wrapper').html("");
        $.post("favorites/deleteEmailItem", { source: source }).done(function () {
            renderFavItems(favWrapper.data('favRenderLink'));

        });
    }

    // Render users favourited items on Favourties page (FavouritesGrid.ss)
    function renderFavItems(link) {
        FavData = JSON.parse(window.localStorage.getItem('favourite_data')) || {};
        if (typeof window.location.hash != 'undefined' && window.location.hash != "" && typeof $(".js-page-title") != 'undefined') {
            $(".js-share-container").hide();
            if (typeof $(".js-page-title") != 'undefined' && $(".js-project-title").data('id') != "" && typeof $(".js-project-title").data('id') != 'undefined') {
                $(".js-page-title").text($(".js-project-title").data('id'));
            }
        }

        loader.appendTo(favWrapper);
        loader.show();

        $.post(link, { Lists: FavData.Events, locationHash: window.location.hash }).done(function (response) {
            appendFavListResponse(response);
            favWrapper.trigger('loadFavItems');
        });
    }

    function appendFavListResponse(response) {
        loader.hide();
        favWrapper.append(response);
        window.setTimeout(() => {
            $('.js-fav-result').each((index, item) => {
                window.initFavIcon(item);
            });
        }, 200);
        dispatchFavEvent('appendFavListResponse');
    }

    function getShareLink(link) {
        if (getConfig('isBackEnd') && getConfig('loggedIn')) {
            return link;
        }
        var events = [];
        for (var list in FavData.Events) {
            if (FavData.Events[list].length) {
                for (var key in FavData.Events[list]) {
                    events.push(FavData.Events[list][key]);
                }
            }
        }
        return link + '?e=' + events.join(',');
    }

    function urlShortnerData(link, callback) {
        var insertLink = getConfig('shortnerLink');
        $.ajax({
            'url': insertLink,
            'data': {
                'URL': link,
            },
            'method': 'POST',
            'dataType': 'json',
            'success': function (data) {
                callback(data);
            }
        });
    }

    function shareOnFacebook(link, title, description) {
        urlShortnerData(getShareLink(link), function (shortLink) {
            if (window.FB) {
                window.FB.ui({
                    method: 'share',
                    href: shortLink,
                    quote: title + ' | ' + description
                },
                    function (response) { });
            }
        });
    }

    function shareOnTwitter(link, title, description) {
        urlShortnerData(getShareLink(link), function (shortLink) {
            var url = 'https://twitter.com/intent/tweet?url=' + shortLink + '&text=' + title + ' | ' + description;
            window.open(url, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=400,width=500');
        });
    }

    function shareEmail(link, title, description) {
        if (!title) {
            title = 'My favourites';
        }

        urlShortnerData(getShareLink(link), function (shortLink) {
            var url = "mailto:?subject=" + title + "&body=" + description + ' ' + shortLink;
            window.location.href = url;
        });
    }

    function shareLink(link) {
        urlShortnerData(getShareLink(link), function (shortLink) {
            var html = '<a href="' + shortLink + '" target="_blank">' + shortLink + '</a>';
            favPopup.find('div').html(html);
            favPopup.show();
        });
    }

    if (!IsMobile()) {
        var cbInst = new Clipboard('._js-copy-clipboard', {
            text: function (trigger) {
                var result = '';
                var insertLink = getConfig('shortnerLink'),
                    shareLink = getShareLink(trigger.getAttribute('share-link'));
                $.ajax({
                    type: "POST",
                    async: false,
                    url: insertLink,
                    data: {
                        'URL': shareLink
                    },
                    success: function (shortLink) {
                        result = shortLink;
                    }
                });
                return result;
            }
        });
        cbInst.on('success', function (e) {
            favPopup.find('div').html('Link copied to clipboard');
            favPopup.show();
            window.setTimeout(function () {
                favPopup.hide();
            }, 2000);
        });
    }

    $('.js-fav-share-item').on('click', function () {
        var $this = $(this),
            wrapper = $this.closest('.js-fav-share'),
            link = wrapper.data('shareLink'),
            title = wrapper.data('title'),
            description = wrapper.data('description');
        if ($this.hasClass('js-twitter')) {
            shareOnTwitter(link, title, description);
        } else if ($this.hasClass('js-facebook')) {
            shareOnFacebook(link, title, description);
        } else if ($this.hasClass('js-email')) {
            shareEmail(link, title, description);
        } else {
            if (IsMobile()) {
                shareLink(link);
            }
        }
    });

    favPopup.on('click', function () {
        favPopup.hide();
    });

    function IsMobile() {
        var check = false;
        (function (a) {
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
                check = true;
            }
        })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
    }

    $(document).ready(function () {
        var button = $('.js-fav-popup__form'),
            favWrapper = button.closest('.js-fav-wrapper'),
            processLink = button.data('process-link');

        if (document.getElementById('ssf-facebook')) {
            $('.js-open-fb-popup').click(function () {
                $.magnificPopup.open({
                    items: {
                        src: '#ssf-facebook',
                        type: 'inline'
                    }
                });
            });
        }

        $(document).on('click', '.js-fav-popup__form', function (e) {
            e.preventDefault();
            $(this).magnificPopup({
                type: 'ajax',
                mainClass: 'mfp-zoom-out', // this class is for CSS animation below
                zoom: {
                    enabled: true,
                    duration: 300,
                    easing: 'ease-in-out'
                },
                closeOnBgClick: false,
                removalDelay: 500,
                closeBtnInside: true,
                callbacks: {
                    beforeOpen: function () {
                        if ($(window).width() < 700) {
                            this.st.focus = false;
                        } else {
                            this.st.focus = '#name';
                        }
                    },
                    ajaxContentAdded: function () {
                        var $form = $("form#Form_FavouriteListForm"),
                            $editButton = this.st.el,
                            favListItem = favWrapper.find('.js-fav-lists-item').last(),
                            favListDom = $('.js-fav-lists');

                        $form.submit(function (e) {
                            var $title = $form.find('input[name="Title"]').val(),
                                $listID = $('#Form_FavouriteListForm_ListID').val();

                            $.ajax({
                                type: "POST",
                                url: processLink,
                                dataType: 'JSON',
                                data: {
                                    'Title': $title,
                                    'ListID': $listID
                                },
                                success: function (data) {
                                    if (data.isEdit && $editButton.hasClass('js-edit-fav-list')) {
                                        $editButton.closest('.js-fav-lists-item').find('.js-list-title').text($title);
                                        if (typeof tzoResetFavListMasonry === 'function') {
                                            tzoResetFavListMasonry();
                                        }
                                    } else if (favListItem && favListItem.length) {
                                        var cloned = favListItem.clone();
                                        cloned.find('.js-list-image').attr('src', cloned.find('.js-empty-list-image').attr('src'));
                                        cloned.find('.js-list-title').text($title);
                                        cloned.find('.js-list-length').text('(0)');
                                        favListDom.append(cloned);
                                        cloned.show('slow');
                                        if (typeof tzoReloadFavListMasonryOnAdd === 'function') {
                                            tzoReloadFavListMasonryOnAdd();
                                        }
                                        cloned.find('.js-delete-fav-list').attr('data-id', data.id);
                                        cloned.find('.js-edit-fav-list').attr('href', window.location.pathname + '/favouritesEditPopup/' + data.id);

                                    } else {
                                        window.location.reload();
                                    }
                                    $.magnificPopup.close();
                                }
                            });

                            e.preventDefault();
                        })
                    }
                }
            }).magnificPopup('open');
        });

        $(document).on('click', '.js-display-actions', function (e) {
            $(this).closest('.js-fav-lists-item').toggleClass('active');
            if (typeof tzoResetFavListMasonry === 'function') {
                tzoResetFavListMasonry();
            }
        });

        $(document).on('click', '.js-delete-fav-list', function (e) {
            e.preventDefault();
            if (confirm(messages.deleleAll)) {
                var $this = $(this);
                $.ajax({
                    type: "POST",
                    url: $this.data('deleteLink'),
                    data: {
                        'id': $this.data('id'),
                        'Lists': {}
                    },
                    dataType: 'JSON',
                    success: function (data) {
                        if (data.deleted) {
                            $this.closest('.js-fav-lists-item').fadeOut(function (e) {
                                $(this).remove();
                                if (typeof tzoResetFavListMasonry === 'function') {
                                    tzoResetFavListMasonry();
                                }
                            });
                            if (favWrapper.length && favWrapper.data('favUpdateLink')) {
                                updateFromBackEnd(favWrapper.data('favUpdateLink'));
                            }
                        }
                    }

                });
            }
            return false;
        });

        $(document).on('click', '.js-new-req', function (e) {
            $.post("favorites/updateTime", { id: $(this).data('id') }).done(function () {
            });
        });



        // check for login/signup errors and show them in popup if exist
        var loginError = $('.js-fb-popup').data('loginError');
        var registerError = $('.js-fb-popup').data('registerError');
        if (loginError || registerError) {

            if (registerError) {
                $('#Form_MemberRegisterForm_error').addClass('bad').html(registerError).show();
            }
            if (document.getElementById('ssf-facebook')) {
                $.magnificPopup.open({
                    closeOnBgClick: false,
                    items: {
                        src: '#ssf-facebook',
                        type: 'inline'
                    },
                    open: function () {
                    }
                });
            }
        }
    });



})(jQuery);
